import styled from 'styled-components'

const PanelFoot = styled.div`
  background-color: ${(props) => props.theme.logoBg};
  height: 20px;
`

export default PanelFoot
